<script>export let radius = 16;
export let padding = 1;
export let gradient = "linear-gradient(180deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0) 100%)";
export let shadowEnabled = false;
export let shadow = "0px 0px 11px 1px rgba(0,0,0,0.35)";
export let shadowInset = false;
export let isEnabled = true;
const toCss = (v) => typeof v === "number" ? `${v}px` : v;
$: resolvedShadow = shadowInset ? `${shadow} inset` : shadow;
</script>

<div
	class:border-frame={isEnabled}
	class:shadow-on={shadowEnabled}
	style="
    --bf-radius: {toCss(radius)};
    --bf-padding: {toCss(padding)};
    --bf-bg: {gradient};
    --bf-shadow: {resolvedShadow};
  "
>
	<slot />
</div>

<style>
	.border-frame {
		position: relative;
		height: 100%;
		width: 100%;
		border-radius: var(--bf-radius);
		box-shadow: none;
}

	.border-frame.shadow-on {
		box-shadow: var(--bf-shadow);
	}

	.border-frame::before {
		content: '';
		position: absolute;
		inset: 0;
		border-radius: var(--bf-radius);
		padding: var(--bf-padding);
		background: var(--bf-bg);
		-webkit-mask:
			linear-gradient(#fff 0 0) content-box,
			linear-gradient(#fff 0 0);
		-webkit-mask-composite: xor;
		mask-composite: exclude;
		pointer-events: none;
		z-index: 2;
	}

	.border-frame > :global(*) {
		position: relative;
		z-index: 1;
	}
</style>
